import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-grid" ref={sectionRef}>
          <div className="about-image">
            <div className="image-wrapper">
              <div className="image-placeholder">
                <span className="placeholder-icon">{'🏫'}</span>
                <span className="placeholder-text">MTC Campus</span>
              </div>
              <div className="experience-badge">
                <span className="exp-number">98%</span>
                <span className="exp-text">Success Rate</span>
              </div>
            </div>
          </div>

          <div className="about-content">
            <div className="section-badge">About Us</div>
            <h2>Building Tomorrow's Leaders Today</h2>
            <p className="about-text">
              MTC School is a beacon of educational excellence with the best faculty.
              We believe in nurturing not just academic brilliance but also character,
              creativity, and critical thinking in our students.
            </p>
            <p className="about-text">
              Our holistic approach to education combines traditional values with modern
              teaching methodologies, ensuring our students are well-prepared for the
              challenges of the 21st century.
            </p>

            <div className="ceo-section">
              <div className="ceo-avatar">
                <img src="/ceo.jpg" alt="Sir Mahveer Kumar Lohia - CEO" />
              </div>
              <div className="ceo-info">
                <h3>Sir Mahveer Kumar Lohia</h3>
                <span className="ceo-title">Founder & CEO</span>
                <p className="ceo-contact">{'📞'} +92 336 3012806</p>
                <p className="ceo-message">
                  "Education is the foundation of a bright future. At MTC School,
                  we are committed to providing world-class education to every student."
                </p>
              </div>
            </div>

            <div className="about-features">
              <div className="feature-item">
                <span className="feature-icon">{'📚'}</span>
                <div className="feature-content">
                  <h4>Quality Education</h4>
                  <p>Comprehensive curriculum designed for excellence</p>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">{'👨‍🏫'}</span>
                <div className="feature-content">
                  <h4>Expert Faculty</h4>
                  <p>Highly qualified and dedicated teachers</p>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">{'🎯'}</span>
                <div className="feature-content">
                  <h4>Modern Facilities</h4>
                  <p>State-of-the-art infrastructure and labs</p>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">{'🌟'}</span>
                <div className="feature-content">
                  <h4>Holistic Development</h4>
                  <p>Focus on academics, sports, and arts</p>
                </div>
              </div>
            </div>

            <a href="#enroll" className="btn btn-primary">Learn More About Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
